import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { task } from 'ember-concurrency';
import { tracked } from '@glimmer/tracking';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<div\n  ...attributes\n  {{did-insert this.reload}}\n  {{did-update this.reload @item @item.invoices.length}}\n>\n  {{#each this.documentTypes as |type|}}\n    <BbField @label={{concat-string type.number type.name}}>\n      <HasMany\n        @item={{@item}}\n        @applicationController={{@applicationController}}\n        @relatedHasMany={{type.relatedHasMany}}\n        @relatedModelType=\'invoice\'\n        @isEditable={{@isEditable}}\n        @total={{type.number}}\n        @saveRelation={{@saveRelation}}\n        @documentType={{type.type}}\n        @action={{this.addRelated}}\n        @actionRemove={{this.removeRelated}}\n        data-test-related-invoices-add-related\n        data-test-remove-related-2\n      />\n    </BbField>\n  {{/each}}\n</div>");

var _dec, _class, _descriptor, _descriptor2;
let RelatedInvoicesComponent = (_dec = task({
  restartable: true
}), _class = class RelatedInvoicesComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "session", _descriptor, this);
    _initializerDefineProperty(this, "documentTypes", _descriptor2, this);
  }
  reload() {
    if (this.isDestroying || this.isDestroyed) return;
    this.loadDocumentTypesTask.perform();
  }
  *loadDocumentTypesTask() {
    const item = this.args.item;
    const relatedInvoiceName = this.args.relatedInvoiceName || 'invoices';
    const organization = this.session.me?.organization;
    let rI = item?.[relatedInvoiceName];
    if (typeof rI?.then === 'function') {
      rI = yield rI;
    }
    if (!rI || rI.isDestroying || this.isDestroying || this.isDestroyed) {
      this.documentTypes = [];
      return;
    }
    const documentTypes = ['estimate', 'invoice', 'receipt', 'order', 'contract', 'ddt'];
    const arr = documentTypes.map(t => {
      const filtered = rI.filter(i => i.document_type === t);
      return {
        type: t,
        // organization can be undefined until session.me resolves (see line above
        // using `?.`); fall back to the raw type so the task never throws.
        name: organization?.get(`${t}s_name`) ?? t,
        relatedHasMany: filtered,
        number: filtered.length
      };
    });
    this.documentTypes = this.args.showOnlyPresent ? arr.filter(item => item.number) : arr;
  }
  addRelated(id) {
    if (typeof this.args.action === 'function') {
      this.args.action(id);
    }
  }
  removeRelated(id) {
    if (typeof this.args.actionRemove === 'function') {
      this.args.actionRemove(id);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "documentTypes", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "reload", [action], Object.getOwnPropertyDescriptor(_class.prototype, "reload"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadDocumentTypesTask", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "loadDocumentTypesTask"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addRelated", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addRelated"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeRelated", [action], Object.getOwnPropertyDescriptor(_class.prototype, "removeRelated"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, RelatedInvoicesComponent);

export { RelatedInvoicesComponent as default };
//# sourceMappingURL=related-invoices.js.map
